import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './Chip.module.scss'

export const Chip = ({
  className = undefined,
  color,
  label,
  size,
  variant,
}) => (
  <Box
    align="center"
    className={cx(styles.chip, styles.color, styles.variant, {
      [styles[color]]: Boolean(color),
      [styles.size]: Boolean(size),
      [styles[size]]: Boolean(size),
      [styles[variant]]: Boolean(variant),
      [className]: Boolean(className),
    })}
    justify="center"
    tagName="span"
  >
    {label}
  </Box>
)
